import _ from 'lodash';

export const localStorageKey = 'language';

export type Locale = 'zh-CN' | 'en-US';

export const getCurrentLocale = (): Locale => {
  const localeInStorage = localStorage.getItem(localStorageKey) || navigator.language;
  return _.get(localeInStorage.split('-'), '0', '') === 'zh' ? 'zh-CN' : 'en-US';
};

export const setCurrentLocale = (locale: string): void => {
  localStorage.setItem(localStorageKey, _.toLower(locale));
};
